import React,{useEffect, useState} from 'react'
import {Link,useLocation,useNavigate,NavLink} from 'react-router-dom'
import { Button} from 'react-bootstrap';
import {Offcanvas} from 'react-bootstrap';


const mainLinks=[{text:"TOne Home",link:"https://www.teluguone.com/"},
  {text:"News",link:"https://www.teluguone.com/news"},
  {text:"Movie News",link:"https://www.teluguone.com/tmdb"},
  {text:"Movies",link:"https://www.teluguone.com/movies"},
  {text:"Photos",link:"https://www.teluguone.com/photos"},
 {text:"Grandalayam",link:"https://www.teluguone.com/grandalayam"}, 
 {text:"Shortfilms",link:"https://www.teluguone.com/shortfilms"}, 
 {text:"Bhakti",link:"https://www.teluguone.com/devotional"},
 {text:"Kids",link:"https://www.kidsone.in"},
 {text:'TORi(Radio)',link:'https://www.teluguoneradio.com'},
{text:"Recipes",link:"https://www.teluguone.com/recipes"},
 {text:"Send Gifts",link:"https://www.teluguone.com/sendgifts"},
  {text:"Astrology",link:"https://www.teluguone.com/toneastrology"},
  {text:"Vanitha",link:"https://www.teluguone.com/vanitha"},
  {text:"Nri Corner",link:"https://www.teluguone.com/nri"},
  {text:"Greetings",link:"https://www.teluguone.com/greetings"},
  {text:"Health",link:"https://www.teluguone.com/health"},
  {text:"Charity",link:"https://www.teluguone.com/charity"},
 ]

    
    const mobileMenuLinks=[{ text: 'TOne Home', link: 'https://www.teluguone.com' },{text:"News",link:"https://www.teluguone.com/news"},{text:"Movie News",link:"https://www.teluguone.com/tmdb"},
  {text:"Movies",link:"https://www.teluguone.com/movies"},{text:"Photos",link:"https://www.teluguone.com/photos"},
  {text:"Grandalayam",link:"https://www.teluguone.com/grandalayam"},{text:"Shortfilms",link:"https://www.teluguone.com/shortfilms"},
  {text:"Bakthi",link:"https://www.teluguone.com/devotional"},{text:"Videos",link:"https://www.teluguone.com/videos"},{text:"Recipes",link:"https://www.teluguone.com/recipes"},
     {text:"Comedy",link:"https://www.teluguone.com/comedy"},{text:"Vanitha",link:"https://www.teluguone.com/vanitha"},{text:"Health",link:"https://www.teluguone.com/health"}]


      const pageLinks=[{text:"HOME",link:""},{text:"MALLIK CORNER",link:"/mallik/maliks-5.html"},
        {text:"SPOOFS",link:"/videos/videos.html"},
        {text:"JOKES",link:"/contents/jokes-23.html"},{text:"STORIES/SERIALS",link:"/storiesserials.html"},
        {text:"FACEBOOK FUN",link:"/contents/facebook-fun-1168.html"},{text:"VIDEOS",link:""},
   ]
   
   const mobilepageLinks=[{text:"HOME",link:""},{text:"Daily Updates",link:"/contents/jokes-23.html"},
    {text:"Shhh Gup Chip",link:"/videoslist/videos-5.html"},
    {text:"Happy Happy Ga",link:"/videoslist/videos-4.html"},
    {text:"Mallik Comedy",link:"/videoslist/videos-6.html"},
    {text:"Erri Dippa",link:"/videoslist/videos-25.html"},
    {text:"Skits",link:"/videoslist/videos-27.html"},
    {text:"Audio Jokes",link:"/contents/audio-jokes-669.html"},
    {text:"Audio Cartoons",link:"/contents/audio-cartoons-6.html"},
     {text:"Mallikkrazy",link:"/contents/mallikkrazy-641.html"}, 
     {text:"Hot Shot",link:"/contents/hot-shot-26.html"},
      {text:"SIGGU SIGGU",link:"/contents/siggu-siggu-25.html"},
    {text:"Facebook Fun",link:"/contents/facebook-fun-1168.html"},
    {text:"Jokes",link:"/contents/jokes-23.html"},
    {text:"Chepey Rayudu",link:"/contents/sakkubai-942.html"}
   ]









const ComedyHeader = ({isMobile}) => {

        const Location=useLocation()
        const address=Location.pathname
        const Navigate=useNavigate();
        
    
        


      const NavigateMenu = (id) => {
            switch (id) {
              case "MallikMenu":
               Navigate("#") 
                break;
              case "SpoofsMenu":
                Navigate("/videos/videos.html")
                break;
              case "VideosMenu":
                Navigate("#")
                break;
            
              default:
                break;
            }
      } 

   



  return (
    <div className='container-fluid comedy-header'>
      
          <div className='row'>
             <div className="col-12 comedy-header-main-links-container">
              <nav>
                {mainLinks.map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.text}
                  </a>
                ))}
              </nav>
             </div>
              <ComedyMobileHeader />
              <div className='col-12 comedy-header-logo-container'>
              <Link to="/">
              <img src="/comedy/assets/images/tone_comedy_logo.webp" alt="comedy-header-logo" className='comedy-header-logo'  />
              </Link>
                <div className='comedy-banners-container'>
                  <Link to="https://www.youtube.com/watch?v=RLnUgn4uKKA" target='_blank'><img src="/comedy/assets/images/tone_fashion.webp" alt="g-h-banner" className='comedy-header-banner' /></Link>
                  <Link to="https://www.youtube.com/c/HealthOne/videos" target='_blank'><img src="/comedy/assets/images/tone_health.webp" alt="g-h-banner" className='comedy-header-banner' /></Link>
                </div>
              </div>

              <div className='col-12 comedy-header-page-links-container'>
                     <nav> 
                   {!isMobile && pageLinks.map((item,index) =>{

                    if (item.text === 'MALLIK CORNER' ) {
                       return (
                        <div key={index} className="dropdown">
                             {/* onClick={() => NavigateMenu("MallikMenu")} */}
                             <Button id="MallikMenuBtn"  className="btn btn-secondary dropdown-toggle comedy-header-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                             MALLIK CORNER
                                </Button>
                                <ul id="MallikMenu" className="dropdown-menu comedy-header-dropdown-menu">
                                  <li><Link className="dropdown-item" to="/contents/audiojokes-669.html">AUDIO JOKES</Link></li>
                                  <li><Link className="dropdown-item" to="/contents/audiocartoons-6.html">AUDIO CARTOONS</Link></li>
                                  <li><Link className="dropdown-item" to="/contents/mallikkrazy-641.html">MALLIK CRAZY</Link></li>
                                  <li><Link className="dropdown-item" to="/galleries/Chitti-Archive-11-1.html">CHITTI</Link></li>
                                  <li><Link className="dropdown-item" to="/contents/hotshot-26.html">HOT SHOT</Link></li>
                                  <li><Link className="dropdown-item" to="/contents/siggusiggu-25.html">SIGGU SIGGU</Link></li>
                                </ul>
                              </div>
                      )
                  
                    }

                    if (item.text === 'SPOOFS') {
                      return (
                        <div key={index} className="dropdown" >
                             <Button id="SpoofsMenuBtn" onClick={() => NavigateMenu("SpoofsMenu")}  className="btn btn-secondary dropdown-toggle comedy-header-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                             SPOOFS
                                </Button>
                                <ul id="SpoofsMenu"  className="dropdown-menu comedy-header-dropdown-menu">
                                  <li><Link className="dropdown-item" to="/videoslist/erridippa-25.html">ERRI DIPPA</Link></li>
                                  <li><Link className="dropdown-item" to="/videoslist/spoofs-26.html">FILM/POLITICAL SPOOFS</Link></li>
                                </ul>
                              </div>
                      )
                    }
                     if (item.text === 'VIDEOS') {
                      return (
                        <div key={index} className="dropdown">
                             <Button id="VideosMenuBtn"  onClick={() => NavigateMenu("VideosMenu")}  className="btn btn-secondary dropdown-toggle comedy-header-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                             VIDEOS
                                </Button>
                                <ul id="VideosMenu"  className="dropdown-menu comedy-header-dropdown-menu">
                                  <li><Link className="dropdown-item" to="/videoslist/mallikcomedy-6.html">MALLIK COMEDY SHOW</Link></li>
                                  <li><Link className="dropdown-item" to="/videoslist/shhhgupchip-5.html">SHH GUP CHIP</Link></li>
                                  <li><Link className="dropdown-item" to="/videoslist/happyhappyga-4.html">HAPPY HAPPY GA</Link></li>
                                  <li><Link className="dropdown-item" to="/videoslist/telugucomedyvideos-14.html">COMEDY EPISODES</Link></li>
                                  <li><Link className="dropdown-item" to="/videoslist/archives-31.html">GOSSIPS</Link></li>
                                </ul>
                              </div>
                      )
                   }
                    else { return (<NavLink  key={index}   to={item.link}  className={({ isActive }) =>    isActive ? "comedy-active-page" : ""   }> {item.text} </NavLink> );}
                   } )}

                   {isMobile && mobilepageLinks.map((item,index) =>{

                             
                                return <NavLink  key={index}   to={item.link}  className={({ isActive }) =>    isActive ? "comedy-active-page" : ""   }> {item.text} </NavLink>
                              
                              
                              } )}
                          
                     </nav>
              </div>
              

          </div>

    </div>
  )
}

export default ComedyHeader;

function  ComedyMobileHeader() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='comedy-mobile-header'>
      <Button   aria-label="Open menu"   variant="primary" onClick={handleShow}>
      <svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true"><path stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" d="M4 7h22M4 15h22M4 23h22"></path></svg>
      </Button>

      <Offcanvas className="comedy-mobile-offcanvas" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
        <img   src={`/comedy/assets/images/tone_logo.webp`}
                        alt="tone-logo" className="header-logo"/>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <nav className="comedy-mobile-header-menu">
                {mobileMenuLinks.map((item,index) => <Link className='comedy-mobile-menu-link' rel="noopener noreferrer"  key={index} to={item.link}>{item.text}</Link>)}
             
            </nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
